module.exports = __webpack_public_path__ + "line-awesome.3f85d8035b4ccd91d2a1.eot";


//////////////////
// WEBPACK FOOTER
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/assets/metronic/src/vendors/line-awesome/fonts/line-awesome.eot??v=1.1.
// module id = ../../../../../src/assets/metronic/src/vendors/line-awesome/fonts/line-awesome.eot??v=1.1.
// module chunks = styles